import type { ClientOverview } from '../../types/api';

/**
 * Calculate average TTM ROI percentage for a client across all units
 * @param clientOverviewData - Array of ClientOverview data for all units
 * @returns Average TTM ROI percentage
 */
export function calculateAverageTTMROI(clientOverviewData: ClientOverview[]): number {
  if (!clientOverviewData || clientOverviewData.length === 0) {
    return 0;
  }

  const validROIs = clientOverviewData
    .map(overview => overview.ttm_roi_percent)
    .filter(roi => roi !== null && roi !== undefined);

  if (validROIs.length === 0) {
    return 0;
  }

  const totalROI = validROIs.reduce((sum, roi) => sum + roi!, 0);
  return totalROI / validROIs.length;
}

/**
 * Calculate average TTM ROI percentage with formatting
 * @param clientOverviewData - Array of ClientOverview data for all units
 * @returns Formatted average TTM ROI percentage string
 */
export function calculateAverageTTMROIFormatted(clientOverviewData: ClientOverview[]): string {
  const averageROI = calculateAverageTTMROI(clientOverviewData);
  
  if (averageROI === 0) {
    return '0%';
  }
  
  // Format with 2 decimal places and percentage sign
  return `${averageROI.toFixed(2)}%`;
}












